import React from 'react';
import {
  Box, Typography,
} from 'vindi-ds-components';
import toBrl from '@utils/format_currency';
import PricingType from './pricing_type';

function SimplePricing({ pricingSchema, unit }) {
  const { price, schema_type: schemaType } = pricingSchema;

  return (
    <Box display='flex' justifyContent='space-between'>
      <Box>
        <Typography variant='body2' component='p'>
          Precificação
        </Typography>
        <Typography variant='subtitle1' component='p'>
          {unit ? `${toBrl(price)}/${unit}` : toBrl(price) }
        </Typography>
      </Box>
      <PricingType schemaType={schemaType} />
    </Box>
  );
}

export default SimplePricing;
